<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header/>
    <Scroll/>
    <div class="hp_productMain_contentWrap">
      <div class="hp_productMain_contentSidebar hp_reservationSidebar">
        <div class="hp_productMain_contentKeywordBox">
          <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
          <div class="hp_productMain_contentKeyword_tagBox">
            <p
                v-for="item in statusData.hotKeywordData"
                :key="item.hot_keyword_ID"
              >
              <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                #{{ item.hot_keyword_name }}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div class="hp_reservationWrap">
        <h4>
          여행예약하기
          <p>아래 정보를 정확히 입력해 주세요.</p>
        </h4>

        <div class="hp_reservationBox"> <!-- 첫번째 : 여행상품정보 -->
          <div class="hp_reservationBoxTit">
            <h5>예약상품정보</h5>
          </div>
          <table class="hp_reservIB" cellpadding="0" cellspacing="0" summary="상품정보">
            <caption>상품정보</caption>
            <colgroup>
              <col width="25%">
              <col width="*">
            </colgroup>
            <tbody>
              <tr>
                <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">상품명</th>
                <td class="info_titText">{{ statusData.scheduleData.travel_product_name }}</td>
              </tr>
              <tr>
                <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">여행기간</th>
                <td>
                  <div class="info_titDate">
                    <ul>
                      <li class="info_titDate_text" v-if="statusData.scheduleData.travel_product_night === 0">당일</li>
                      <li class="info_titDate_text" v-else>{{ statusData.scheduleData.travel_product_night }}박 {{ statusData.scheduleData.travel_product_day }}일</li>
                      <li class="info_titDate_ico">출발일</li>
                      <li>{{statusData.scheduleData.schedule_start_day }}</li>
                      <li class="info_titDate_ico">도착일</li>
                      <li>{{statusData.scheduleData.schedule_end_day }}</li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="hp_reservationBox"> <!-- 두번째 : 예약자 정보 -->
          <div class="hp_reservationBoxTit">
            <h5>예약자정보</h5>
            <div><span class="pointTextRed">*</span> 필수항목</div>
          </div>
          <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="예약자정보">
            <caption>예약자정보</caption>
            <colgroup>
              <col width="25%">
              <col width="*">
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <label for = 'reservation_customer_name'>예약자명 <span class="pointTextRed">*</span></label>
                </th>
                <td>
                  <input
                    type="text"
                    class="hp_reservBox_input"
                    id = 'reservation_customer_name'
                    v-model="formData.reservationCustomerName"
                    maxlength="10"
                  >
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for = 'reservation_customer_phone_number'>휴대전화 <span class="pointTextRed">*</span></label>
                </th>
                <td>
                  <input
                    type = "text"
                    class="hp_reservBox_input"
                    id = 'reservation_customer_phone_number'
                    v-model="formData.reservationCustomerPhoneNumber"
                    maxlength="13"
                  >
                </td>
              </tr>
              <tr>
                <th>
                  <label for = 'reservation_customer_phone_number2'>비상연락처</label>
                </th>
                <td>
                  <input
                    type = "text"
                    class="hp_reservBox_input"
                    id = 'reservation_customer_phone_number2'
                    v-model="formData.reservationCustomerPhoneNumber2"
                    maxlength="13"
                  >
                </td>
              </tr>
              <tr>
                <th>
                  <label for = 'reservation_customer_email'>이메일</label>
                </th>
                <td>
                  <input
                    type = "text"
                    class="hp_reservBox_input"
                    id = 'reservation_customer_email'
                    v-model="formData.reservationCustomerEmail"
                    maxlength="50"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="hp_reservationBox"> <!-- 세번째 : 상세예약 정보 -->
          <div class="hp_reservationBoxTit">
            <h5>
              상세예약정보
            </h5>
          </div>
          <div class="hp_reservOptionBox">
            <!-- 옵션 A : 인원 선택 -->
            <div v-if="statusData.reservationData.scheduleOptionUseStatus === 2 && Object.keys(statusData.scheduleData).length">
              <ul>
                <li class="hp_optionBox_tit">
                  예약 가능 좌석
                </li>
                <li class="hp_selectBox">
                  {{statusData.totalSeats}}명
                </li>
              </ul>
              <ul>
                <li class="hp_optionBox_tit">
                  대인 선택
                  <p>(1인 : {{statusData.scheduleData.schedule_price.toLocaleString()}} 원)</p>
                </li>
                <li class="hp_selectBox">
                  <select  v-model="statusData.selectedAdults" @change="updateSelection('adults')">
                    <option value="0">선택해주세요.</option>
                    <option :key="n" v-for="n in availableAdultSeats(statusData.totalSeats)" :value="n">대인 {{ n }}명</option>
                  </select>
                </li>
              </ul>
              <ul>
                <li class="hp_optionBox_tit">
                  소인 선택
                  <p>(1인 : {{statusData.scheduleData.schedule_price_child.toLocaleString()}} 원)</p>
                </li>
                <li class="hp_selectBox">
                  <select v-model="statusData.selectedChildren" @change="updateSelection('children')">
                    <option value="0">선택해주세요.</option>
                    <option :key="n" v-for="n in availableChildSeats(statusData.totalSeats, statusData.selectedAdults)" :value="n">소인 {{ n }}명</option>
                  </select>
                </li>
              </ul>
              <ul>
                <li class="hp_optionBox_tit">
                  예상 금액
                </li>
                <li class="hp_selectBox hp_optionBox_prePrice">
                  {{statusData.totalPrice.toLocaleString()}}<span>원</span>
                </li>
              </ul>
            </div>

            <!-- 옵션 B : 타입 2개 선택, 인원 선택 -->
            <div v-if="statusData.reservationData.scheduleOptionUseStatus === 1">
              <div v-if="statusData.scheduleGroupOptionRows.length > 0">
                <div v-for="(group, index) in statusData.groups" :key="index" class="hp_optionBoxSection">
                  <ul>
                    <li class="hp_optionBox_tit">
                      {{ statusData.scheduleData.schedule_group_option_title }}
                    </li>
                    <li class="hp_selectBox">
                      <select v-model="group.selectedGroupOption" @change="resetOptions(group)">
                        <option value="0">선택해주세요.</option>
                        <option v-for="groupOption in statusData.scheduleGroupOptionRows" :key="groupOption.schedule_group_option_ID" :value="groupOption.schedule_group_option_ID">
                          {{ groupOption.schedule_group_option_name }}
                        </option>
                      </select>
                    </li>
                  </ul>
                  <div v-if="group.selectedGroupOption !== 0" v-for="option in filteredGroupOptions(group)" :key="option.schedule_option_ID">
                    <ul>
                      <li class="hp_optionBox_tit">
                        {{ option.schedule_option_name }}
                      </li>
                      <li class="hp_selectBox">
                        <select v-model="group.selectedOptionList" @change="updateSelectedOptionDetails(group)">
                          <option value="0">선택해주세요.</option>
                          <option v-for="list in optionLists(option.schedule_option_ID)" :key="list.schedule_option_list_ID" :value="list.schedule_option_list_ID">
                            {{ list.schedule_option_list_name }}
                          </option>
                        </select>
                      </li>
                    </ul>
                  </div>
                  <div v-if="group.selectedOptionList !== 0">
                    <ul>
                      <li class="hp_optionBox_tit">
                        예약 가능 좌석
                      </li>
                      <li class="hp_selectBox">
                        {{ availableSeats(group.selectedOptionList) }}명
                      </li>
                    </ul>
                    <ul>
                      <li class="hp_optionBox_tit">
                        대인 선택
                        <p>(1인 : {{ group.selectedOptionDetails.schedule_option_list_price.toLocaleString() }} 원)</p>
                      </li>
                      <li class="hp_selectBox">
                        <select v-model="group.selectedAdults" @change="updateSelectionOption('adults', group, group.selectedOptionList)">
                          <option value="0">선택해주세요.</option>
                          <option :key="n" v-for="n in availableAdultSeats(group.availableSeats)" :value="n">{{ n }}명</option>
                        </select>
                      </li>
                    </ul>
                    <ul>
                      <li class="hp_optionBox_tit">
                        소인 선택
                        <p>(1인 : {{ group.selectedOptionDetails.schedule_option_list_price_child.toLocaleString() }} 원)</p>
                      </li>
                      <li class="hp_selectBox">
                        <select v-model="group.selectedChildren" @change="updateSelectionOption('children', group, group.selectedOptionList)">
                          <option value="0">선택해주세요.</option>
                          <option :key="n" v-for="n in availableChildSeats(group.availableSeats, group.selectedAdults)" :value="n">{{ n }}명</option>
                        </select>
                      </li>
                    </ul>
                    <ul>
                      <li class="hp_optionBox_tit">
                        예상 금액
                      </li>
                      <li class="hp_selectBox hp_optionBox_prePrice" v-if="group.totalPriceValid">
                        {{ totalPriceGroup(group).toLocaleString() }}<span>원</span>
                      </li>
                      <li class="hp_selectBox hp_optionBox_errorBox" v-else>
                        예약 인원을 맞춰주세요.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="hp_selectBtn">
                  <button class="hp_selectBtnMinus" @click="removeGroup(index)">-</button>
                  <button class="hp_selectBtnPlus" @click="addGroup()">+</button>
                </div>
                <div class="hp_optionBox_totalPrePrice">
                  <span>총 예상 금액 : </span>
                  <span>{{ totalGroupPrice() }}</span>원
                </div>
              </div>

              <!-- 옵션 C : 타입 1개 선택, 인원 선택 -->
              <div v-else>
                <div v-for="(group, index) in statusData.groups" :key="index" class="hp_optionBoxSection">
                  <div v-for="option in statusData.scheduleOptionRows" :key="option.schedule_option_ID">
                    <ul>
                      <li class="hp_optionBox_tit">
                        {{ option.schedule_option_name }}
                      </li>
                      <li class="hp_selectBox">
                        <select v-model="group.selectedOptionList" @change="updateSelectedOptionDetails(group)">
                          <option value="0">선택해주세요.</option>
                          <option v-for="list in optionLists(option.schedule_option_ID)" :key="list.schedule_option_list_ID" :value="list.schedule_option_list_ID">
                            {{ list.schedule_option_list_name }}
                          </option>
                        </select>
                      </li>
                    </ul>
                  </div>
                  <div v-if="group.selectedOptionList !== 0">
                    <ul>
                      <li class="hp_optionBox_tit">
                        예약 가능 좌석
                      </li>
                      <li class="hp_selectBox">
                        {{ availableSeats(group.selectedOptionList) }}명
                      </li>
                    </ul>
                    <ul>
                      <li class="hp_optionBox_tit">
                        대인 선택
                        <p>(1인 : {{ group.selectedOptionDetails.schedule_option_list_price.toLocaleString() }} 원)</p>
                      </li>
                      <li class="hp_selectBox">
                        <select v-model="group.selectedAdults" @change="updateSelectionOption('adults', group, group.selectedOptionList)">
                          <option value="0">선택해주세요.</option>
                          <option :key="n" v-for="n in availableAdultSeats(group.availableSeats)" :value="n">{{ n }}명</option>
                        </select>
                      </li>
                    </ul>
                    <ul>
                      <li class="hp_optionBox_tit">
                        소인 선택
                        <p>(1인 : {{ group.selectedOptionDetails.schedule_option_list_price_child.toLocaleString() }} 원)</p>
                      </li>
                      <li class="hp_selectBox">
                        <select v-model="group.selectedChildren" @change="updateSelectionOption('children', group, group.selectedOptionList)">
                          <option value="0">선택해주세요.</option>
                          <option :key="n" v-for="n in availableChildSeats(group.availableSeats, group.selectedAdults)" :value="n">{{ n }}명</option>
                        </select>
                      </li>
                    </ul>
                    <ul>
                      <li class="hp_optionBox_tit">예상 금액</li>
                      <li class="hp_selectBox hp_optionBox_prePrice" v-if="group.totalPriceValid">
                        {{ totalPriceGroup(group).toLocaleString() }}원
                      </li>
                      <li class="hp_selectBox hp_optionBox_errorBox" v-else>
                        예약 인원을 맞춰주세요.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="hp_selectBtn">
                  <button class="hp_selectBtnMinus" @click="removeGroup(index)">-</button>
                  <button class="hp_selectBtnPlus" @click="addGroupWithoutOption()">+</button>
                </div>
                <div class="hp_optionBox_totalPrePrice">
                  <span>총 예상 금액 : </span>
                  <span>{{ totalGroupPrice() }}</span>원
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hp_reservationBox"> <!-- 네번째 : 실제 여행자정보 :: 다시작성함 -->
          <div class="hp_reservationBoxTit">
            <h5>실제여행자정보</h5>
          </div>

          <div class="hp_termsAllBox" v-if="formData.reservationSeatArray.length === 0">
            <label>인원을 선택해주세요.</label>
          </div>

          <div class="hp_termsAllBox" v-if="formData.reservationSeatArray.length !== 0">
            <input type="checkbox" id="people_check" v-model="statusData.isSameAsReserver" @change="copyReserverToFirstSeat">
            <label for="people_check">예약자와 대표자가 같습니다.</label>
          </div>

          <!-- 모바일용 -->
          <table
            class="hp_reserveInfoBoxMo"
            cellpadding="0"
            cellspacing="0"
            summary="실제여행자정보"
            v-if="formData.reservationSeatArray.length !== 0"
          >
            <caption>실제여행자정보</caption>
            <colgroup>
              <col width="25%">
              <col width="*">
            </colgroup>
            <tbody v-for="(seat, index) in formData.reservationSeatArray" :key="index" class="hp_reserveInfoBoxMo_table">
              <tr>
                <th scope="row">이름</th>
                <td>
                  <div>
                    <input
                      type="text"
                      maxlength="10"
                      :placeholder="index === 0 ? '대표자명' : '예약자명'"
                      class="hp_reserveInfoBoxMo_input"
                      v-model="seat.reservation_seat_customer_name"/>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">연락처</th>
                <td>
                  <div>
                    <input
                      type="tel"
                      maxlength="13"
                      placeholder="-제외 연락처 작성"
                      class="hp_reserveInfoBoxMo_input"
                      v-model="seat.reservation_seat_customer_phone_number"/>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">생년월일</th>
                <td>
                  <div class="hp_reserveInfoBoxMo_selectDateBox">
                    <input
                      type="date"
                      max="2999-12-31"
                      maxlength="10"
                      class="hp_reserveInfoBoxMo_input hp_reserveInfoBoxMo_selectDate"
                      v-model="seat.reservation_seat_customer_birthday"/>
                  </div>
                  <div class="hp_reserveInfoBoxMo_select" style="float:right;">
                    <select v-model="seat.reservation_seat_customer_gender">
                      <option value="1">남</option>
                      <option value="2">여</option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">탑승지</th>
                <td>
                  <div class="hp_reserveInfoBoxMo_select">
                    <select v-model="seat.reservation_seat_departure_station">
                      <option
                        :value = "item"
                        v-for="item in JSON.parse(statusData.scheduleData.schedule_boarding)"
                        :key="item"
                      >
                        {{item}}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- pc용 -->
          <table
            class="hp_reserveInfoBoxPc"
            border="0"
            cellspacing="0"
            cellpadding="0"
            summary="실제여행자정보"
            v-if="formData.reservationSeatArray.length !== 0"
          >
            <caption>실제여행자정보</caption>
            <colgroup>
              <col width="15%">
              <col width="30%">
              <col width="30%">
              <col width="*">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">이름</th>
                <th scope="col">연락처</th>
                <th scope="col">생년월일</th>
                <th scope="col">탑승지</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(seat, index) in formData.reservationSeatArray" :key="index">
                <td>
                  <div>
                    <input
                      type="text"
                      maxlength="10"
                      :placeholder="index === 0 ? '대표자명' : '예약자명'"
                      class="hp_reserveInfoBoxPc_input"
                      v-model="seat.reservation_seat_customer_name"/>
                  </div>
                </td>
                <td>
                  <div>
                    <input
                      type="tel"
                      maxlength="13"
                      placeholder="-제외 연락처 작성"
                      class="hp_reserveInfoBoxPc_input"
                      v-model="seat.reservation_seat_customer_phone_number"/>
                  </div>
                </td>
                <td class="displayFlexSpaceCenter">
                  <div class="hp_reserveInfoBoxPc_selectDateBox">
                    <input
                      type="date"
                      max="2999-12-31"
                      maxlength="10"
                      class="hp_reserveInfoBoxPc_input hp_reserveInfoBoxPc_selectDate"
                      v-model="seat.reservation_seat_customer_birthday"/>
                  </div>
                  <div class="hp_reserveInfoBoxPc_select" >
                    <select v-model="seat.reservation_seat_customer_gender">
                      <option value="1">남</option>
                      <option value="2">여</option>
                    </select>
                  </div>
                </td>
                <td>
                  <div class="hp_reserveInfoBoxPc_select">
                    <select v-model="seat.reservation_seat_departure_station">
                      <option
                        :value = "item"
                        v-for="item in JSON.parse(statusData.scheduleData.schedule_boarding)"
                        :key="item"
                      >
                        {{item}}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="hp_reservationBox"> <!-- 다섯번째 : 결제정보 -->
          <div class="hp_reservationBoxTit">
            <h5>결제정보</h5>
          </div>
          <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="결제정보">
            <caption>결제정보</caption>
            <colgroup>
              <col width="27%">
              <col width="*">
            </colgroup>
            <tbody>
              <tr>
                <th>예약 인원</th>
                <td>
                  <template v-if="statusData.reservationData.scheduleOptionUseStatus === 2">
                    {{ statusData.selectedAdults + statusData.selectedChildren }}명
                  </template>
                  <template v-else>
                    {{ statusData.groups.reduce((total, group) => total + group.selectedAdults + group.selectedChildren, 0) }}명
                  </template>
                </td>
              </tr>
              <tr v-if="statusData.scheduleData.travel_product_point !== 0">
                <th>적립 포인트</th>
                <td>
                  <template v-if="sessionData.customer !== ''">
                    <template v-if="statusData.reservationData.scheduleOptionUseStatus === 2">
                      {{ ((statusData.selectedAdults + statusData.selectedChildren) * statusData.scheduleData.travel_product_point).toLocaleString() }}포인트
                      (1인 {{ statusData.scheduleData.travel_product_point.toLocaleString() }}포인트)
                    </template>
                    <template v-else>
                      {{ (statusData.groups.reduce((total, group) => total + group.selectedAdults + group.selectedChildren, 0) * statusData.scheduleData.travel_product_point).toLocaleString() }}포인트
                      (1인 {{ statusData.scheduleData.travel_product_point.toLocaleString() }}포인트)
                    </template>
                  </template>
                  <p v-else>회원가입 시 포인트를 적립 할 수 있습니다.</p>
                </td>
              </tr>
              <tr>
                <th scope="row">결제방식</th>
                <td>
                  <div class="hp_paymentSelectBox">
                    <select v-model="formData.reservationPaymentMethod" aria-placeholder="결제방식을 선택하세요.">
                      <option value="" disabled selected>결제방식을 선택해주세요.</option>
                      <option value="0">무통장 입금</option>
                      <option value="1">신용카드</option>
                    </select>
                    <div v-if="formData.reservationPaymentMethod === '0'">
                      <div class="hp_paymentBankCopy" @click="copyToClipboard">
                        입금계좌안내
                        <p>{{ statusData.accountInfo }}</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="formData.reservationPaymentMethod === '0'">
                <th scope="row">입금자명</th>
                <td>
                  <input class = "hp_reservBox_input" type="text" id="reservation_depositor_name" v-model="formData.reservationDepositorName" placeholder="입금자명을 입력하세요">
                  <span class="hp_reservCheckbox">
                    <input type="checkbox" id="sameAsReserver" v-model="statusData.sameAsReserver" @change="copyReserverInfo">
                    <label for="sameAsReserver"><span></span>예약자와 동일</label>
                  </span>
                  <span class="hp_reservCheckbox">
                    <input type="checkbox" id="reservation_cash_receipt_request" v-model="formData.reservationCashReceiptRequest">
                    <label for="reservation_cash_receipt_request"><span></span>현금영수증 요청</label>
                  </span>
                </td>
              </tr>
              <tr v-if="sessionData.customer !== ''">
                <th scope="row">포인트 사용</th>
                <td>
                  <input
                    class="hp_reservBox_input"
                    type="text"
                    id="reservation_use_points"
                    v-model="formData.reservationUsePoints"
                    :placeholder="`최대 ${statusData.sumPoint.toLocaleString()} 포인트 사용 가능`"
                    :max="statusData.sumPoint"
                    />
                  <span class="hp_reservCheckbox">
                    <input type="checkbox" id="allUse" v-model="statusData.isAllPointsUsed" @change="useMaxPoints">
                    <label for="allUse"><span></span>전액사용</label>
                    <span class="hp_reservBox_point">보유포인트 : <em>{{statusData.sumPoint.toLocaleString()}}</em>Point</span>
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">남기실 말씀</th>
                <td>
                  <textarea
                    id = 'reservation_customer_name'
                    v-model="formData.reservationRequest"
                    :maxlength="500"
                    placeholder="남기실 말씀을 입력해주세요 (최대 500자)"
                    cols="120"
                    rows="6"
                    class="hp_reservTextarea">
                  </textarea>
                  <p class="hp_reservTextareaNum">{{ formData.reservationRequest.length }}/500</p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="hp_optionBox_totalPrePrice" style="margin-top:30px;">
            <span>최종 결제 금액 : </span>
            <span>
              <template v-if="statusData.reservationData.scheduleOptionUseStatus === 2">
                {{ statusData.totalPrice.toLocaleString() }}
              </template>
              <template v-else>
                {{ totalGroupPrice() }}
              </template>
            </span>원
          </div>
        </div>

        <div class="hp_commuDetail_privacyBox"> <!-- 댓글 작성 약관 동의 -->
          <div class="hp_commuDetail_pbAll">
            <input  type="checkbox" id="agreeAll" v-model="formData.agreeAll" @change="toggleAllAgreements" />
            <label for="agreeAll">이용약관 및 개인정보방침에 모두 동의합니다.</label>
          </div>
          <div class="hp_commuDetail_pbEarch">
            <div>
              <input type="checkbox" id="agree4" v-model="formData.agree4" @change="checkIndividualAgreements" />
              <label for="agree4"><span>[필수]</span> 서비스 이용약관에 동의</label>
            </div>
            <button type="button" @click="togglePopup(4)">약관보기</button>
          </div>
          <div class="hp_commuDetail_pbEarch">
            <div>
              <input type="checkbox" id="agree1" v-model="formData.agree1" @change="checkIndividualAgreements" />
              <label for="agree1"><span>[필수]</span> 수집하는 개인정보의 항목에 동의</label>
            </div>
            <button type="button" @click="togglePopup(1)">약관보기</button>
          </div>
          <div class="hp_commuDetail_pbEarch">
            <div>
              <input type="checkbox" id="agree2" v-model="formData.agree2" @change="checkIndividualAgreements" />
              <label for="agree2"><span>[필수]</span> 개인정보의 수집 이용목적에 동의</label>
            </div>
            <button type="button" @click="togglePopup(2)">약관보기</button>
          </div>
          <div class="hp_commuDetail_pbEarch">
            <div>
              <input type="checkbox" id="agree3" v-model="formData.agree3" @change="checkIndividualAgreements" />
              <label for="agree3"><span>[필수]</span> 개인정보의 보유 및 이용기간에 동의</label>
            </div>
            <button type="button" @click="togglePopup(3)">약관보기</button>
          </div>
        </div>

        <!-- 모바일용 예약하기 버튼 : 클릭 시 예약 완료 페이지로 이동함 -->
        <div class="hp_reservation_btnReservMob">
          <button @click="handleReservation">예약하기</button>
        </div>
        <!-- PC용 에약하기, 취소하기 버튼 -->  <!-- 반응형할때 조절하기! -->
        <div class="hp_reservation_btnReservPc">
          <button class="hp_reservation_btnReservPc_on" @click="handleReservation">예약하기</button>
          <button>취소하기</button>
        </div>
      </div>
    </div>
    <PopupComponent
      :isVisible="statusData.isPopupVisible"
      :toggleStatus="statusData.toggleStatus"
      @update:isVisible="statusData.isPopupVisible = $event"
    />
    <Footer/>
  </div>
</template>

<!-- eslint-disable camelcase -->
<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import Spiner from '../Section/Spiner.vue'
import PopupComponent from '../Section/PopupComponent.vue'
import { ref } from 'vue'
import {
  get_schedule_one,
  get_session_customer,
  get_point_sum,
  get_hot_keyword_top10,
  base_url_export,
  inicis_export,
  buildStatus,
  insert_reservation
} from '../../ETC/Axios.vue'
import {
  removeWhitespacePhone,
  removeWhitespaceStandardPhone
} from '../../ETC/Validation.vue'

export default {
  name: 'Reservation',
  components: {
    Header,
    Footer,
    Scroll,
    Spiner,
    PopupComponent
  },
  setup () {
    return {
      sessionData: ref({
        customer: ''
      }),
      statusData: ref({
        spinnerStatus: false,
        hotKeywordData: [],
        accountInfo: '(주)행복을주는사람들 / 우리은행 1005-303-875864',
        isSameAsReserver: false,
        sameAsReserver: false,
        reservationData: [],
        totalSeats: 0,
        selectedAdults: 0,
        selectedChildren: 0,
        totalPrice: 0,
        groups: [],
        scheduleData: [],
        scheduleGroupOptionRows: [],
        scheduleOptionRows: [],
        scheduleOptionListRows: [],
        selectedItem: '',
        toggleStatus: 1,
        isPopupVisible: false,
        sumPoint: 0,
        isAllPointsUsed: false
      }),
      formData: ref({
        reservationCustomerName: '',
        reservationCustomerPhoneNumber: '',
        reservationCustomerPhoneNumber2: '',
        reservationCustomerEmail: '',
        reservationNumberArray: [],
        reservationSeatArray: [],
        reservationPaymentMethod: '',
        reservationDepositorName: '',
        reservationCashReceiptRequest: false,
        reservationRequest: '',
        reservationUsePoints: '0',
        agreeAll: false,
        agree4: false,
        agree1: false,
        agree2: false,
        agree3: false
      })
    }
  },
  methods: {
    copyReserverToFirstSeat () {
      if (this.statusData.isSameAsReserver && this.formData.reservationSeatArray.length > 0) {
        this.formData.reservationSeatArray[0].reservation_seat_customer_name = this.formData.reservationCustomerName
        this.formData.reservationSeatArray[0].reservation_seat_customer_phone_number = this.formData.reservationCustomerPhoneNumber
      } else if (this.formData.reservationSeatArray.length > 0) {
        this.formData.reservationSeatArray[0].reservation_seat_customer_name = ''
        this.formData.reservationSeatArray[0].reservation_seat_customer_phone_number = ''
      }
    },
    copyToClipboard () {
      if (this.formData.reservationPaymentMethod === '0') {
        const textarea = document.createElement('textarea')
        textarea.textContent = this.statusData.accountInfo
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        textarea.remove()
        alert('클립보드에 복사되었습니다.')
      }
    },
    copyReserverInfo () {
      if (this.statusData.sameAsReserver) {
        this.formData.reservationDepositorName = this.formData.reservationCustomerName
      } else {
        this.formData.reservationDepositorName = ''
      }
    },
    togglePopup (toggleStatus) {
      this.statusData.toggleStatus = toggleStatus
      this.statusData.isPopupVisible = !this.statusData.isPopupVisible
    },
    toggleAllAgreements () {
      this.formData.agree1 = this.formData.agreeAll
      this.formData.agree2 = this.formData.agreeAll
      this.formData.agree3 = this.formData.agreeAll
      this.formData.agree4 = this.formData.agreeAll
    },
    checkIndividualAgreements () {
      if (this.formData.agree1 && this.formData.agree2 && this.formData.agree3 && this.formData.agree4) {
        this.formData.agreeAll = true
      } else {
        this.formData.agreeAll = false
      }
    },
    filteredGroupOptions (group) {
      if (!group.selectedGroupOption) return []
      return this.statusData.scheduleOptionRows.filter(
        option => option.schedule_group_option_ID_use_schedule_option === group.selectedGroupOption
      )
    },
    availableSeats (listId) {
      const list = this.statusData.scheduleOptionListRows.find(list => list.schedule_option_list_ID === listId)
      if (!list) {
        return 0
      }
      const available = list.schedule_option_list_seats - list.reservation_number_count - list.reservation_number_count_child
      return available
    },
    availableAdultSeats (availableSeats) {
      const seats = availableSeats || 0
      return Array.from({ length: seats }, (_, i) => i + 1)
    },
    availableChildSeats (availableSeats, selectedAdults) {
      const seats = (availableSeats || 0) - (selectedAdults || 0)
      return Array.from({ length: seats }, (_, i) => i + 1)
    },
    totalPriceGroup (group) {
      if (!group.selectedOptionDetails) return 0
      const adultsPrice = group.selectedAdults * (group.selectedOptionDetails.schedule_option_list_price || 0)
      const childrenPrice = group.selectedChildren * (group.selectedOptionDetails.schedule_option_list_price_child || 0)
      return adultsPrice + childrenPrice
    },
    totalGroupPrice () {
      const groupTotal = this.statusData.groups.reduce((total, group) => {
        const groupPrice = (group.selectedAdults * ((group.selectedOptionDetails && group.selectedOptionDetails.schedule_option_list_price) || 0)) +
                       (group.selectedChildren * ((group.selectedOptionDetails && group.selectedOptionDetails.schedule_option_list_price_child) || 0))
        return total + groupPrice
      }, 0)

      const usedPoints = Math.min(Number(this.formData.reservationUsePoints.replace(/,/g, '') || 0), Number(this.statusData.sumPoint || 0))
      const finalPrice = Math.max(groupTotal - usedPoints, 0)

      return finalPrice.toLocaleString()
    },
    addGroup () {
      this.statusData.groups.push({
        selectedGroupOption: 0,
        selectedOptionList: 0,
        selectedAdults: 0,
        selectedChildren: 0,
        availableSeats: 0,
        selectedOptionDetails: {},
        totalPriceValid: true
      })
    },
    addGroupWithoutOption () {
      this.statusData.groups.push({
        selectedOptionList: 0,
        selectedAdults: 0,
        selectedChildren: 0,
        availableSeats: 0,
        selectedOptionDetails: {},
        totalPriceValid: true
      })
    },
    updateSelectedOptionDetails (group) {
      const selectedOption = this.statusData.scheduleOptionListRows.find(
        option => option.schedule_option_list_ID === group.selectedOptionList
      )
      group.selectedAdults = 0
      group.selectedChildren = 0
      if (selectedOption) {
        group.selectedOptionDetails = selectedOption
        group.availableSeats = this.availableSeats(group.selectedOptionList)
      } else {
        group.selectedOptionDetails = null
        group.availableSeats = 0
      }
      this.updateReservationSeatArray()
    },
    removeGroup (index) {
      if (this.statusData.groups.length > 0) {
        this.statusData.groups.pop()
      }
      this.updateReservationSeatArray()
    },
    resetOptions (group) {
      group.selectedOptionList = 0
      group.selectedAdults = 0
      group.selectedChildren = 0
      this.updateReservationSeatArray()
    },
    updateReservationSeatArray () {
      if (this.statusData.reservationData.scheduleOptionUseStatus === 2) {
        const totalSeats = this.statusData.selectedAdults + this.statusData.selectedChildren
        const currentSeats = this.formData.reservationSeatArray.slice(0, totalSeats)

        while (currentSeats.length < totalSeats) {
          currentSeats.push({
            reservation_seat_customer_name: '',
            reservation_seat_customer_phone_number: '',
            reservation_seat_customer_birthday: '',
            reservation_seat_customer_gender: '1',
            reservation_seat_departure_station: this.statusData.selectedItem
          })
        }

        this.formData.reservationSeatArray = currentSeats
      } else {
        let newReservationSeatArray = []

        this.statusData.groups.forEach(group => {
          for (let i = 0; i < group.selectedAdults + group.selectedChildren; i++) {
            newReservationSeatArray.push({
              reservation_seat_customer_name: '',
              reservation_seat_customer_phone_number: '',
              reservation_seat_customer_birthday: '',
              reservation_seat_customer_gender: '1',
              reservation_seat_departure_station: this.statusData.selectedItem
            })
          }
        })

        this.formData.reservationSeatArray = newReservationSeatArray
      }
    },
    updateSelection (type) {
      if (type === 'adults') {
        this.statusData.selectedChildren = Math.min(this.statusData.selectedChildren, this.statusData.totalSeats - this.statusData.selectedAdults)
      } else if (type === 'children') {
        if (this.statusData.selectedAdults === 0 && this.statusData.selectedChildren > 0) {
          alert('먼저 대인을 선택해주세요.')
          this.statusData.selectedChildren = 0
        } else {
          this.statusData.selectedAdults = Math.min(this.statusData.selectedAdults, this.statusData.totalSeats - this.statusData.selectedChildren)
        }
      }
      this.calculateTotalPrice()
      this.updateReservationSeatArray()
    },
    calculateTotalPrice () {
      const usedPoints = Math.min(this.formData.reservationUsePoints.replace(/,/g, '') || 0, this.statusData.sumPoint || 0)

      if (this.statusData.reservationData.scheduleOptionUseStatus === 2) {
        const totalBeforePoints = (this.statusData.selectedAdults * this.statusData.scheduleData.schedule_price) + (this.statusData.selectedChildren * this.statusData.scheduleData.schedule_price_child)
        this.statusData.totalPrice = Math.max(totalBeforePoints - usedPoints, 0)
      }
      this.$forceUpdate()
    },
    useMaxPoints () {
      if (this.statusData.isAllPointsUsed) {
        this.formData.reservationUsePoints = this.statusData.sumPoint.toLocaleString()
      } else {
        this.formData.reservationUsePoints = '0'
      }
      this.calculateTotalPrice()
    },
    formatPoints (value) {
      const numericValue = value.replace(/,/g, '')
      return Number(numericValue).toLocaleString()
    },
    optionLists (optionId) {
      return this.statusData.scheduleOptionListRows.filter(list => list.schedule_option_ID_use_schedule_option_list === optionId)
    },
    updateSelectionOption (type, group, optionListId) {
      const selectedOptionList = this.statusData.scheduleOptionListRows.find(
        list => list.schedule_option_list_ID === optionListId
      )

      if (!selectedOptionList) return

      group.selectedOptionDetails = selectedOptionList

      if (type === 'adults') {
        group.selectedAdults = Math.min(
          group.selectedAdults,
          selectedOptionList.schedule_option_list_seats -
          selectedOptionList.reservation_number_count -
          selectedOptionList.reservation_number_count_child
        )
      } else if (type === 'children') {
        if (group.selectedAdults === 0 && group.selectedChildren > 0) {
          alert('먼저 대인을 선택해주세요.')
          group.selectedChildren = 0
        } else {
          group.selectedChildren = Math.min(
            group.selectedChildren,
            selectedOptionList.schedule_option_list_seats -
          selectedOptionList.reservation_number_count -
          selectedOptionList.reservation_number_count_child -
          group.selectedAdults
          )
        }
      }

      const totalSelected = group.selectedAdults + group.selectedChildren
      if (
        totalSelected % group.selectedOptionDetails.schedule_option_list_seats_max !== 0
      ) {
        this.$set(group, 'totalPriceValid', false)
      } else {
        this.$set(group, 'totalPriceValid', true)
      }

      this.checkTotalSeats(group)
      this.updateReservationSeatArray()
    },
    checkTotalSeats (group) {
      const optionListSeats = {}

      this.statusData.groups.forEach(g => {
        if (g.selectedOptionList) {
          if (!optionListSeats[g.selectedOptionList]) {
            optionListSeats[g.selectedOptionList] = {
              selectedSeats: 0,
              availableSeats: 0
            }
          }
          optionListSeats[g.selectedOptionList].selectedSeats += g.selectedAdults + g.selectedChildren
          const selectedOptionList = this.statusData.scheduleOptionListRows.find(
            list => list.schedule_option_list_ID === g.selectedOptionList
          )
          if (selectedOptionList) {
            optionListSeats[g.selectedOptionList].availableSeats = selectedOptionList.schedule_option_list_seats - selectedOptionList.reservation_number_count - selectedOptionList.reservation_number_count_child
          }
        }
      })

      const currentOptionListSeats = optionListSeats[group.selectedOptionList]

      if (currentOptionListSeats.selectedSeats > currentOptionListSeats.availableSeats) {
        this.$set(group, 'totalPriceValid', false)
        alert('예약 가능한 좌석 수를 초과했습니다.')
      }

      this.$forceUpdate()
    },
    handleReservation () {
      if (!this.formData.reservationCustomerName) {
        alert('예약자명을 입력해주세요.')
        return
      }
      if (!this.formData.reservationCustomerPhoneNumber) {
        alert('휴대전화를 입력해주세요.')
        return
      }
      const firstSeat = this.formData.reservationSeatArray[0]
      if (!firstSeat.reservation_seat_customer_name) {
        alert('대표자명을 입력해주세요.')
        return
      }
      if (!firstSeat.reservation_seat_customer_phone_number) {
        alert('대표자 연락처를 입력해주세요.')
        return
      }
      if (!firstSeat.reservation_seat_departure_station) {
        alert('대표자 탑승지를 선택해주세요.')
        return
      }
      if (this.formData.reservationPaymentMethod === '' && !this.formData.reservationDepositorName) {
        alert('결제방식을 선택해주세요.')
        return
      }
      if (this.formData.reservationPaymentMethod === '0' && !this.formData.reservationDepositorName) {
        alert('입금자명을 입력해주세요.')
        return
      }
      if (!this.formData.agree4 || !this.formData.agree1 || !this.formData.agree2 || !this.formData.agree3) {
        alert('모든 약관에 동의해주세요.')
        return
      }
      if (this.statusData.reservationData.scheduleOptionUseStatus === 2) {
        if (this.statusData.selectedAdults === 0) {
          alert('대인은 필수로 선택해주세요.')
          return
        }
        if (!this.statusData.totalPrice) {
          alert('올바른 총 가격을 입력해주세요.')
          return
        }
      }

      if (this.statusData.reservationData.scheduleOptionUseStatus === 1) {
        for (let group of this.statusData.groups) {
          if (group.selectedAdults === 0) {
            alert('대인은 필수로 선택해주세요.')
            return
          }
          if (!group.totalPriceValid) {
            alert('옵션별로 올바른 총 가격을 입력해주세요.')
            return
          }
        }
      }

      let amount = this.statusData.reservationData.scheduleOptionUseStatus === 2
        ? this.statusData.totalPrice
        : this.totalGroupPrice().replace(/,/g, '')

      const customerID = this.sessionData.customer === '' ? '0' : this.sessionData.customer.customer_ID
      const pointAmount = this.sessionData.customer === ''
        ? 0
        : (this.statusData.reservationData.scheduleOptionUseStatus === 2
          ? (this.statusData.selectedAdults + this.statusData.selectedChildren) * this.statusData.scheduleData.travel_product_point
          : this.statusData.groups.reduce((total, group) => total + group.selectedAdults + group.selectedChildren, 0) * this.statusData.scheduleData.travel_product_point)

      const processReservation = (imp_uid = '', merchant_uid = '') => {
        insert_reservation(
          customerID,
          this.formData.reservationCustomerName,
          this.formData.reservationCustomerPhoneNumber,
          this.formData.reservationCustomerPhoneNumber2,
          this.formData.reservationCustomerEmail,
          amount,
          amount,
          pointAmount,
          this.formData.reservationUsePoints.replace(/,/g, ''),
          this.formData.reservationPaymentMethod,
          this.formData.reservationDepositorName,
          this.formData.reservationCashReceiptRequest,
          this.formData.reservationRequest,
          this.formData.agree4,
          this.formData.agree1,
          this.formData.agree2,
          this.statusData.reservationData,
          this.formData.reservationSeatArray,
          imp_uid,
          merchant_uid,
          this.statusData.scheduleData.schedule_price,
          this.statusData.scheduleData.schedule_price_child
        ).then((result) => {
          if (result.status === 'success') {
            if (this.formData.reservationPaymentMethod === '1') {
              alert('결제가 완료되었습니다.')
              this.$router.push({
                path: '/ReservationSuccess',
                query: {
                  reservation_payment_method: this.formData.reservationPaymentMethod,
                  reservation_ID: result.reservation_ID
                }
              })
            } else {
              alert('무통장 입금요청이 완료되었습니다.')
              this.$router.push({
                path: '/ReservationSuccess',
                query: {
                  reservation_payment_method: this.formData.reservationPaymentMethod,
                  reservation_ID: result.reservation_ID
                }
              })
            }
          }
        })
      }

      if (this.formData.reservationPaymentMethod === '1') {
        const reservationData = {
          customer_ID_use_reservation: this.sessionData.customer === '' ? '0' : this.sessionData.customer.customer_ID,
          reservation_customer_name: this.formData.reservationCustomerName,
          reservation_customer_phone_number: this.formData.reservationCustomerPhoneNumber,
          reservation_customer_phone_number_2: this.formData.reservationCustomerPhoneNumber2,
          reservation_customer_email: this.formData.reservationCustomerEmail,
          reservation_expected_payment_amount: amount,
          reservation_payment_amount: amount,
          reservation_accumulated_points: pointAmount,
          reservation_use_points: this.formData.reservationUsePoints.replace(/,/g, ''),
          reservation_payment_method: this.formData.reservationPaymentMethod,
          reservation_depositor_name: this.formData.reservationDepositorName,
          reservation_cash_receipt_request: this.formData.reservationCashReceiptRequest,
          reservation_request: this.formData.reservationRequest,
          reservation_terms_of_use: this.formData.agree4,
          reservation_privacy_statement: this.formData.agree1,
          reservation_electronic_terms_and_conditions: this.formData.agree2,
          reservationDataArray: JSON.stringify(this.statusData.reservationData),
          reservationSeatArray: JSON.stringify(this.formData.reservationSeatArray),
          reservation_number_price: this.statusData.scheduleData.schedule_price,
          reservation_number_price_child: this.statusData.scheduleData.schedule_price_child
        }

        const queryParams = new URLSearchParams(reservationData).toString()

        const IMP = window.IMP
        const paymentData = {
          pg: inicis_export,
          pay_method: 'card',
          merchant_uid: `mid_${new Date().getTime()}`,
          name: this.statusData.scheduleData.travel_product_name,
          amount: buildStatus === 'test' ? 1000 : amount,
          buyer_name: this.formData.reservationCustomerName,
          buyer_tel: this.formData.reservationCustomerPhoneNumber,
          buyer_email: this.formData.reservationCustomerEmail,
          buyer_addr: '',
          m_redirect_url: `${base_url_export}reservation/mobile_insert_reservation?${queryParams}`
        }
        IMP.request_pay(paymentData, (response) => {
          // 테스트 시 !response.success로 진행
          if (response.success) {
            processReservation(response.imp_uid, response.merchant_uid)
          } else {
            alert(`결제 실패: ${response.error_msg}`)
          }
        })
      } else {
        processReservation()
      }
    }
  },
  watch: {
    'formData.reservationCustomerName': function (value) {
      if (this.statusData.isSameAsReserver && this.formData.reservationSeatArray.length > 0) {
        this.formData.reservationSeatArray[0].reservation_seat_customer_name = value
      }
    },
    'formData.reservationCustomerPhoneNumber': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.reservationCustomerPhoneNumber = removeWhitespacePhone(cleanValue)
      if (this.statusData.isSameAsReserver && this.formData.reservationSeatArray.length > 0) {
        this.formData.reservationSeatArray[0].reservation_seat_customer_phone_number = removeWhitespaceStandardPhone(cleanValue)
      }
    },
    'formData.reservationCustomerPhoneNumber2': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.reservationCustomerPhoneNumber2 = removeWhitespaceStandardPhone(cleanValue)
    },
    'formData.reservationSeatArray': {
      handler (newValue) {
        newValue.forEach((seat, index) => {
          const cleanValue = seat.reservation_seat_customer_phone_number.replace(/\D/g, '')
          seat.reservation_seat_customer_phone_number = removeWhitespaceStandardPhone(cleanValue)
        })
      },
      deep: true
    },
    'statusData.selectedAdults': 'updateReservationSeatArray',
    'statusData.selectedChildren': 'updateReservationSeatArray',
    'statusData.groups': {
      handler: 'updateReservationSeatArray',
      deep: true
    },
    'formData.reservationUsePoints': function (newVal) {
      const maxPoints = this.statusData.sumPoint
      const numericValue = newVal.replace(/,/g, '')
      if (Number(numericValue) > maxPoints) {
        this.formData.reservationUsePoints = maxPoints.toLocaleString()
      } else {
        this.formData.reservationUsePoints = this.formatPoints(newVal)
      }
      this.calculateTotalPrice()
    }
  },
  mounted () {
    this.statusData.reservationData = JSON.parse(localStorage.getItem('reservationData'))
    get_schedule_one(this.statusData.reservationData.scheduleID).then((result) => {
      this.statusData.scheduleData = result.schedule_rows[0]
      this.statusData.selectedItem = JSON.parse(this.statusData.scheduleData.schedule_boarding)[0]
      if (this.statusData.reservationData.scheduleOptionUseStatus === 2) {
        this.statusData.totalSeats = result.schedule_rows[0].schedule_seats - result.schedule_rows[0].reservation_number_count - result.schedule_rows[0].reservation_number_count_child
        this.statusData.selectedAdults = this.statusData.reservationData.selectedAdults
        this.statusData.selectedChildren = this.statusData.reservationData.selectedChildren
        this.updateSelection('adults')
      } else {
        this.statusData.groups = this.statusData.reservationData.groups
        if (this.statusData.reservationData.scheduleGroupOptionUseStatus === 0) {
          result.schedule_option_rows = result.schedule_option_rows.filter(
            option => option.schedule_group_option_ID_use_schedule_option === 0
          )
          this.statusData.scheduleGroupOptionRows = []
        } else {
          result.schedule_option_rows = result.schedule_option_rows.filter(
            option => option.schedule_group_option_ID_use_schedule_option !== 0
          )
          this.statusData.scheduleGroupOptionRows = result.schedule_group_option_rows
        }
        this.statusData.scheduleOptionRows = result.schedule_option_rows
        this.statusData.scheduleOptionListRows = result.schedule_option_list_rows
      }
      this.updateReservationSeatArray()
    })
    get_session_customer().then(result => {
      this.sessionData.customer = result
      if (this.sessionData.customer !== '') {
        this.formData.reservationCustomerName = result.customer_name
        this.formData.reservationCustomerPhoneNumber = result.customer_phone_number
        this.formData.reservationCustomerEmail = result.customer_email
        get_point_sum(result.customer_ID).then(result_point => {
          this.statusData.sumPoint = result_point[0].sum_point
        })
      }
    })
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Reservation/Reservation.vue